import { render, staticRenderFns } from "./simplifyOwnerTransactionCar.vue?vue&type=template&id=05634db2&scoped=true"
import script from "./simplifyOwnerTransactionCar.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerTransactionCar.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerTransactionCar.vue?vue&type=style&index=0&id=05634db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05634db2",
  null
  
)

export default component.exports